import { VideoCardLayout } from "../../../../../components/cards/VideoCard/VideoCardLayout";
import { type VideoCardBaseProps } from "../../../../../components/cards/VideoCard/types";
import { PublishStatus } from "components/common/PublishStatus";
import { PublishedStatusTypes } from "../../../../../enums";
import dateTimeUtils from "../../../../../utils/dateTimeUtils";
import { type VideoOverview } from "../../types/models";
import { VideoContentItemMenu } from "../VideoContentItemMenu/VideoContentItemMenu";

import "./videoOverviewCard.scss";

export interface VideoOverviewCardProps extends VideoCardBaseProps<VideoOverview> {
  handleEditClick: (id: number, isDraft: boolean) => () => void;
  handlePublishClick: (id: number, isDraft: boolean, flowsCount: number, hasBeenPublished: boolean) => () => void;
  handleDeleteClick: (id: number[], flowsCount?: number, packsCount?: number) => () => void;
  onToggleVisibility: (id: number[], hidden: boolean) => () => void;
}

export const VideoOverviewCard = (props: VideoOverviewCardProps) => {
  const { item, disabled, selected, onSelect } = props;

  return (
    <VideoCardLayout
      onSelect={onSelect}
      item={item}
      selected={selected}
      disabled={disabled}
      url={item.id.toString()}
      className="video-overview-card no-hover-state"
      visibility={!item.visibility}
    >
      <div className="top-row">Added {dateTimeUtils.formatDate(item.dateCreated)}</div>

      <div className="bottom-row">
        <PublishStatus
          publishedStatus={PublishedStatusTypes.ConvertToPublishedStatusType(!item?.isDraft, item.hasBeenPublished)}
        />
        <VideoContentItemMenu circle {...props} item={item} isChecked={selected} readonly={disabled || selected} />
      </div>
    </VideoCardLayout>
  );
};
